import type { SyntheticEvent } from 'react';

/**
 * `cancel` handler of a <dialog>: Escape closes it through `close`. A file
 * input inside the dialog fires a bubbling `cancel` of its own when its picker
 * is dismissed (Chrome 113+, Firefox 91+): that one must leave the dialog open.
 */
export const dialogCancelHandler =
  (close: () => void) => (event: SyntheticEvent<HTMLDialogElement>) => {
    if (event.target !== event.currentTarget) return;
    event.preventDefault();
    close();
  };
